function exec(fnName: string, message: string, ...optionalParams: unknown[]) {
  if (typeof console === 'undefined') {
    return;
  }

  const consoleFn = (console as unknown as Record<string, unknown>)[fnName] as (
    message: string,
    ...optionalParams: unknown[]
  ) => void;
  if (!consoleFn) {
    return;
  }
  consoleFn(message, ...optionalParams);
}

export const log = (message: string, ...optionalParams: unknown[]) => {
  exec('log', message, ...optionalParams);
};

export const info = (message: string, ...optionalParams: unknown[]) => {
  exec('info', message, ...optionalParams);
};

export const warn = (message: string, ...optionalParams: unknown[]) => {
  exec('warn', message, ...optionalParams);
};

export const error = (message: string, ...optionalParams: unknown[]) => {
  exec('error', message, ...optionalParams);
};
